<script>
export default {
    name: "BreadCrumbItem",
    props: {
        title: String,
        cache: Boolean,
    },
    mounted() {
        this.$store.commit('UPDATE_BREAD_CRUMBS');
    },
    computed: {
        breadcrumb() {
            return {
                text: this.title,
            };
        },
    },
    watch: {
        breadcrumb() {
            this.$store.commit('UPDATE_BREAD_CRUMBS');
        },
    },
}
</script>

<template>
    <keep-alive v-if="cache">
        <router-view v-bind="$attrs"></router-view>
    </keep-alive>
    <router-view v-else v-bind="$attrs"></router-view>
</template>

<style scoped lang="scss">

</style>
